// extracted by mini-css-extract-plugin
export var center = "_6f-2";
export var clickableRow = "_6f-5";
export var expandedRow = "_6f-7";
export var hoverable = "_6f-4";
export var left = "_6f-1";
export var right = "_6f-3";
export var row = "_6f-0";
export var selectedRow = "_6f-6";
export var summaryRow = "_6f-8";